// Actions a page performs on its own state rather than by clicking a control. A shortcut that clicks
// a control fails whenever that control is not mounted -- the stats sidebar mounts only the open
// panel -- so the page that owns the state registers what the shortcut should do instead.
export type PageAction = {
  perform: () => void
  // whether the shortcut is offered at all; absent means always
  isAvailable?: () => boolean
}

const registry = new Map<string, PageAction>()
const listeners = new Set<() => void>()

// The shortcut list is built when the bar mounts, usually before the page has registered anything,
// and a shortcut outside that list does not answer its keys; so every change is announced.
export const pageActionsChanged = () => listeners.forEach(listener => listener())

export const subscribePageActions = (listener: () => void) => {
  listeners.add(listener)

  return () => {
    listeners.delete(listener)
  }
}

// Returns the unregister function, which leaves a newer registration under the same id alone.
export const registerPageAction = (id: string, action: PageAction) => {
  registry.set(id, action)
  pageActionsChanged()

  return () => {
    if (registry.get(id) !== action) return
    registry.delete(id)
    pageActionsChanged()
  }
}

export const getPageAction = (id: string) => registry.get(id) ?? null
